import { roundToDecimalPlaces } from '@semios/app-platform-common'

export const formatHours = (value: number): string => {
  return String(roundToDecimalPlaces(value / 60, 1) ?? 0)
}
